import styled from "styled-components";

const ColorWrapper = styled.div`
  ${({ $isBorder, $isBg, $isColor, $color }) => `
    ${$isBg ? `background-color: ${$color} !important;` : ""}
    ${$isColor ? `color: ${$color} !important;` : ""}
    ${$isBorder ? `border-color: ${$color} !important;` : ""}
  `}
`;

const RequiredLabel = styled.label`
  position: relative;
  font-size: 14px;
  font-weight: bold;

  &::after {
    content: "必要";
    color: #fc3c60;
    right: -55px;
    top: 2px;
    position: absolute;
  }
`;

const ButtonStyled = styled.button`
  ${({ $isBorder, $isBg, $isColor, $color }) => `
    ${$isBg ? `background-color: ${$color} !important;` : ""}
    ${$isColor ? `color: ${$color} !important;` : ""}
    ${$isBorder ? `border-color: ${$color} !important;` : ""}
    border-radius: 30px;
    background-color: #fff;
  `}
`;

const HoverEffect = styled.div`
  ${({ $color, $bgColor, $isActive }) => `
  ${
    $isActive
      ? `
    &:hover {
      background-color: ${$bgColor} !important;
      color: ${$color} !important;
    }
  `
      : ""
  }
`}
`;

export { ColorWrapper, RequiredLabel, ButtonStyled, HoverEffect };
